// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

// Internal Dependencies
import Colours from '../../../styles/colours';

const useStyles = makeStyles(() => ({
  button: {
    border:       `1px solid ${Colours.Black}`,
    padding:      '6px 26px',
    borderRadius: '100px',
    fontSize:     '14px',
  },
  disabled: {
    opacity: 0.5,
  },
  default: {
    backgroundColor: Colours.White,
    color:           Colours.Black,
  },
  primary: {
    backgroundColor: Colours.Primary,
    color:           Colours.White,
    border:          'none',
  },
  draft: {
    backgroundColor: Colours.Gray4,
    color:           Colours.Black,
  },
  live: {
    backgroundColor: Colours.Green1,
    color:           Colours.White,
  },
  delete: {
    backgroundColor: Colours.Red,
    color:           Colours.White,
  },
  selected: {
    backgroundColor: Colours.Gray,
    color:           Colours.White,
  },
}));

const PillButton = ({ text, type, btnStyle, selected, disabled, className, children, ...rest }) => {
  const classes = useStyles();

  return (
    // eslint-disable-next-line react/button-has-type
    <button disabled={disabled} type={type || 'button'} {...rest} className={clsx([classes.button, classes[btnStyle.toLowerCase()], selected && classes.selected, disabled && classes.disabled, className])}>
      {children}
      {' '}
      {text}
    </button>
  );
};

export default PillButton;

PillButton.propTypes = {
  text:      PropTypes.string,
  btnStyle:  PropTypes.string,
  selected:  PropTypes.bool,
  disabled:  PropTypes.bool,
  type:      PropTypes.string,
  className: PropTypes.string,
  children:  PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

PillButton.defaultProps = {
  text:      '',
  type:      'button',
  btnStyle:  'default',
  selected:  false,
  disabled:  false,
  className: '',
  children:  null,
};
